import styles from "./social.module.css";

const Social = () => {
  return (
    <ul className={styles.main}>
      <li>
        <a
          href="https://github.com/ankitkumar3443"
          aria-label="GitHub"
          target="_blank"
          rel="noreferrer"
        > <i className="fab fa-github"></i>
        </a>
      </li> 
      <li> 
        <a
          href="https://www.linkedin.com/in/ankit-kumar-92113b201/"
          aria-label="LinkedIn"
          target="_blank"
          rel="noreferrer"
        > <i className="fab fa-linkedin" aria-hidden="true"></i>
        </a>
      </li> 
      <li> 
        <a
          href="https://drive.google.com/file/d/1sLKk18eRX87qDkzlgWH2vIrP5GllcLua/view"
          aria-label="Resume"
          target="_blank"
          rel="noreferrer"
        > 
        <i className="fas fa-file"></i>
        </a>
      </li>
      <li> 
        <a
          href="https://twitter.com/ankitkumar3443"
          aria-label="twitter"
          target="_blank"
          rel="noreferrer"
        > <i class="fab fa-twitter-square" aria-hidden="true"></i>
        </a>
      </li> 
      <li> 
      <a
            href="https://wa.me/917277350695"
            aria-label="WhatsApp"
            target="_blank"
            rel="noreferrer"
          >
            {" "}
            <i className="fab fa-whatsapp"></i>
          </a>
      </li> 
      {/* <li className={styles.line}></li> */}
    </ul>
  );
};

export default Social;
